import React, { useState } from 'react';
import CommonCard from '../atoms/CommonCard';
import axios from '../../../config/axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { service } from '../../../services/AxiosServices';
import ConfirmDialog from './ConfirmDialog';
// FlowCard component displays a flow's details in a card, 
// allowing navigation to an edit page and deletion of the flow with appropriate API calls.

interface Flow{
    id:number;
    name:string;
    updatedOn: string;
    description:string;
    createdBy: string;
    agents:number
  }

interface FlowCardtProps {
  flow: Flow
  crewName:string
  onDelete: (id: number) => void; 
  crewId:number
}


const FlowCard: React.FC<FlowCardtProps> = ({ flow, onDelete ,crewName,crewId}) => {
  const navigate = useNavigate();
   const [showDelete, setShowDelete] = useState(false);
   const confirmDelete = () => {
    setShowDelete(true);
  };

  const handleDelete = async ()=>{
      try{
     
          const response =  await service(
                 "/api/delete-flow/",
                  "post",
                    {
                      id:flow.id
                    }
                );
   
           toast.success('Flows deleted successfully',{autoClose:2000})
       
          onDelete(Number(flow.id))
      }  
      catch(err){
            console.log(err)
      }
      finally {
        setShowDelete(false);
      }
    }

  return (
    <>
    <CommonCard
      id={flow.id}
      title={flow.name}
      entityType="Flow"
      details={[
        { label: 'Updated on', value: flow.updatedOn },
        { label: 'Created by', value: flow.createdBy },
        { label: 'Number of agents', value: flow.agents?.toString() },
        { label: 'Flow ID', value: `00${flow.id}` },
      ]}
      onEdit={() => navigate(`/edit-flow/${crewId}/flow/${flow.id}`,{state:{crewName}})}
      onDelete={confirmDelete}
    />
     <ConfirmDialog
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleDelete}
        title="Confirm delete"
        body={`Are you sure you want to delete the ${flow.name}?`}
        confirmText="Delete"
      />
    </>
    
  );
};

export default FlowCard;
